module.exports = __webpack_public_path__ + "static/media/complaints.1e791dd4.pdf";